import { inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";
import { WaveupRole } from "@ennova-research/waveup-common/types";
import { PermissionUtils } from "@ennova-research/waveup-common/utils/permission.utils";
import { map } from "rxjs";
import { ROUTE } from "../../../shared/utils/routes";
import { AuthService } from "../../services/auth/auth.service";
import { RouteData } from "../../types/waveup-routes.types";

export const roleGuard: CanActivateFn = (route) => {
  const router = inject(Router);

  return inject(AuthService)
    .getCurrentUserAndOnBehalfOfUser()
    .pipe(
      map(({ currentUser, onBehalfOfUser }) => {
        if (!currentUser) {
          // This code should never be reached since the auth guard already checks that the user is logged
          console.warn("Reached unexpected code");
          return false;
        }

        const routeData: RouteData = route.data;
        if (!routeData.roles || routeData.roles.length === 0) {
          return true;
        }

        const hasOnBehalfRole =
          onBehalfOfUser?.role &&
          PermissionUtils.assertRole(
            { role: onBehalfOfUser?.role },
            { roles: routeData.roles }
          );
        const hasUserRole = PermissionUtils.assertRole(
          { role: currentUser.role },
          { roles: routeData.roles }
        );

        if (hasUserRole || hasOnBehalfRole) {
          return true;
        } else {
          return customHomeRedirect(router, currentUser.role);
        }
      })
    );
};

function customHomeRedirect(router: Router, role: WaveupRole): UrlTree {
  switch (role) {
    case "admin":
      return router.parseUrl(ROUTE.USERS);
    case "tem":
    case "tem-manager":
      return router.parseUrl(ROUTE.TEM_CLIENT);
    case "user":
    case "enterprise-admin":
      return router.parseUrl(ROUTE.COMPANIES_DASHBOARD);
    case "sales":
      return router.parseUrl(ROUTE.COMPANIES_DASHBOARD);
  }
}
